import { BaseDivHomePage } from '@/main/components/layouts/homepageLayout/styles';
import styled from 'styled-components';

export const Container = styled.div`
  img {
    object-fit: cover;
  }

  #id-image-2 {
    object-fit: cover;
    object-position: 30% 0;
  }

  #id-image-3 {
    object-fit: cover;
    object-position: 90%;
  }
  #id-image-4 {
    object-fit: cover;
    object-position: 50%;
  }
`;

export const TitleLandingPage = styled.h1`
  font-size: 4rem;
  width: 100%;
  font-weight: bold;
  
  > span {
    display: block;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2.4rem;
  }
`;

export const AreaSectionLandingPage = styled(BaseDivHomePage)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  gap: 1rem;
  /* max-width: 400px; */
  margin-right: auto;

  > button {
    font-size: 2rem;
  }
`;

export const ImageLine = styled.img`
  width: 100%;
  margin: 1rem 0;
`;

export const SectionConfianza = styled(BaseDivHomePage)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 2rem;
  padding: 6rem 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 2rem 1rem;
  }
`;

export const AreaTitleConfianza = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  font-size: 1.6rem;
  font-weight: bold;
  color: ${({ theme }) => theme.white};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    text-align: center;
  }
`;

export const AreaCardCompanyType = styled(BaseDivHomePage)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 2rem 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    padding: 2rem 1rem;
    justify-content: center;
  }
`;

